<div id="fileListDiv">
<div class="fileinfo" *ngFor="let f of workspaceService.fileInfos()">
    <p class="filekey">{{ f.key }}</p>
    <p class="filedetails"><button class="fileDownloadButton" (click)="workspaceService.downloadFile(f)">
        <i class="material-icons" title="Download" aria-label="Download">cloud_download</i></button> Modified: {{ f.lastmodified }} Size: {{ f.size }}</p>
        
</div>
<button class="bigButton fileUploadButton" (click)="workspaceService.showUploadForm()">
    <i class="material-icons" title="Upload" aria-label="Upload">add</i></button>
<button class="bigButton fileListRefreshButton" (click)="workspaceService.refreshFileList()">
        <i class="material-icons" title="Refresh" aria-label="Refresh">refresh</i></button>
    
</div>

<div id="downloadForm" hidden>
    <form action="{{ workspaceService.downloadUrl }}" method="post">
        <input type="text" name="csrfmiddlewaretoken" required id="id_csrfmiddlewaretoken">
        <input type="text" name="key" required id="id_key">
        <input type="text" name="endpoint" required id="id_endpoint">
        <input type="text" name="access" required id="id_access">
        <input type="text" name="secret" required id="id_secret">
        <input type="text" name="bucket" required id="id_bucket">
        <input type="submit" value="Submit" id="id_submit">
    </form>
</div>

<div id="uploadForm" *ngIf="workspaceService.uploadToken()">
    <div id="uploadFormTitle">
        Upload files
        <button id="hideUploadFormButton" type="button" (click)="workspaceService.hideUploadForm()" class="btn-close" 
        aria-label="Cancel" title="Cancel"></button>
    </div>
    <div id="uploadFormBody">
        <p>Select the files to upload as one item to be used as a process input.</p>
        <input type="file" name="files" required multiple id="id_up_files">
        <p>The bounding box for the data as a list of four numbers:<br>min_longitude, min_latitude, max_longitude, max_latitude</p>
        <input type="text" name="bbox" id="id_up_bbox">
        <button class="bigButton fileUploadSubmitButton" (click)="workspaceService.submitUploadForm()">
            <i class="material-icons" title="Upload" aria-label="Upload">add</i></button>
    </div>
</div>
